  <!-- 司机档案 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 车辆档案新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="topLine">司机信息</div>
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" @changeCallback="rowCallback">
        <template slot="img1">
          <uploadimgs @input="changeFileList_1" :fileNameLists="fileNameLists_1" :limit="2" />
        </template>
        <template slot="img2">
          <uploadimgs @input="changeFileList_2" :fileNameLists="fileNameLists_2" :limit="2" />
        </template>
        <template slot="slotLabel">
          <div class="imglists" style="margin-top:16px;">
            <div class="setper" v-if="listShipper.length">
              <div class="s_tem" v-for="(item, index) in listShipper" :key="index">
                <span>{{item.label}}</span>
                <i class="el-icon-error" @click="clickDel(index)"></i>
              </div>
            </div>
            <el-button style="margin-top: 10px" size="small" class="glo_bgcMainColor" @click="addlistShipper">添加</el-button>
          </div>
        </template>
      </dia-form>

      <div class="topLine">运输从业资格证</div>
      <dia-form :diaFormConfig="diaFormConfig2" :baseModel="defaultBaseModel.qualificationReq" ref="diaform2" :Reset="isShowDialog">
        <template slot="img3">
          <uploadimgs @input="changeFileList_3" :fileNameLists="fileNameLists_3" :limit="9" />
        </template>
      </dia-form>
    </my-dialog>
    <myDialog :diaWidth="diaWidth1" :dialogTitle="dialogTitle1" :isShowDialog="isShowDialog1" @handleCloseDia="handleCloseDia1" @diaCancelBtn="handleCloseDia1" @diaConfirmBtn="diaConfirmBtn1">
      <div class="formbox" v-if="isShowDialog1">
        <el-form class="glo_formBox" label-width="80px">
          <el-form-item label="新标签:" style="width:100%;">
            <el-input v-model="dialogForm1.label" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />
    </exportCompoent>
  </div>
</template>
    <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "司机档案", //导出时默认文件名
        apiName: "/admin/v3/tms/driver/getDriverList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      listShipper: [],
      diaWidth1: "350px",
      dialogTitle1: "添加标签",
      isShowDialog1: false,
      dialogForm1: {
        label: "",
      },
      fileNameLists_1: [],
      fileNameLists_2: [],
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:driver:addDriver",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:driver:udpateDriver",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:driver:delDriver",
        },
        {
          name: "启用",
          method: "startUsing",
          permissVal: "admin:driver:startDriver",
        },
        {
          name: "禁用",
          method: "Disable",
          permissVal: "admin:driver:stopDriver",
        },
        {
          name: "转正",
          method: "modifyClick",
          // method: "becomeRegularWorker",
          // permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "姓名",
          field: "driverName",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "身份证号",
          field: "idCard",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "驾驶证号",
          field: "driverLicenseNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "手机号",
          field: "phone",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "电话",
          field: "tel",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "状态",
          field: "driverStatus",
          placeholder: "请选择",
          selectOptions: [
            { label: "启用", val: "qi_yong:driver_status" },
            { label: "禁用", val: "jin_yong:driver_status" },
          ],
        },
      ],

      queryData: {
        driverLicenseNumber: null,
        driverName: null,
        driverStatus: null,
        idCard: null,
        ownerName: null,
        phone: null,
        tel: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "DriverArchive", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:driver:udpateDriver",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:driver:delDriver",
            },
            {
              method: "startUsing",
              methodName: "启用",
              permissVal: "admin:driver:startDriver",
            },
            {
              method: "Disable",
              methodName: "禁用",
              permissVal: "admin:driver:stopDriver",
            },
          ],
        },
        {
          name: "画像标签",
          field: "portraitLabel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "driverStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "档案属性",
          field: "driverArchivalAttribute",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "属性",
          field: "driverAttributeName",
          sort: 4,
          isShow: true,
        },
        {
          name: "工号",
          field: "jobNumber",
          sort: 5,
          isShow: true,
          isSort: true,
        },
        {
          name: "姓名",
          field: "driverName",
          sort: 5,
          isShow: true,
        },
        {
          name: "手机",
          field: "phone",
          sort: 6,
          isShow: true,
          isSort: true,
        },
        {
          name: "电话",
          field: "tel",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "地址",
          field: "address",
          sort: 1,
          isShow: true,
        },
        {
          name: "身份证号",
          field: "idCard",
          sort: 18,
          isShow: true,
        },
        {
          name: "驾驶证号",
          field: "driverLicenseNumber",
          sort: 19,
          isShow: true,
          isSort: true,
        },
        {
          name: "司机类型",
          field: "driverTypeName",
          sort: 1,
          isShow: true,
        },
        {
          name: "驾驶证有效日期",
          field: "periodOfValidity",
          width: "160",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "账号",
          field: "username",
          sort: 1,
          isShow: true,
          isSort: true,
        },

        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          sort: 2,
          isShow: true,
        },
      ],
      sortName: "司机档案", //  排序名
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "司机档案",
      isShowDialog: false,
      driverArchivalAttributeConfDictIdArrs: [],
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "属性",
              itemType: "select",
              field: "driverAttributeConfDictId",
              selectChange: "AttributeChange",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "类型",
              itemType: "select",
              field: "driverTypeConfDictId",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "归属承运商",
              itemType: "selectloadmore",
              field: "carrierId",
              loadmoreMethod: "loadCarrier",
              remotemethod: "remoteCarrier",
              loading: false,
              setLabel: "name",
              setValue: "documentId",
              placeholder: "输入承运商进行匹配",
              options: [],
            },
            {
              span: 8,
              title: "员工",
              itemType: "selectloadmore",
              field: "employeeId",
              loadmoreMethod: "load_employeeId",
              remotemethod: "remote_employeeId",
              selectChange: "selectChange_employeeId",
              loading: false,
              setLabel: "employeeName",
              setValue: "employeeId",
              placeholder: "输入员工进行匹配",
              options: [],
            },
            {
              span: 8,
              title: "档案属性",
              itemType: "select",
              field: "driverArchivalAttributeConfDictId",
              placeholder: "请选择",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "工号",
              itemType: "input",
              field: "jobNumber",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "姓名",
              itemType: "input",
              field: "driverName",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "手机",
              itemType: "input",
              field: "phone",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "电话",
              itemType: "input",
              field: "tel",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "身份证号",
              itemType: "input",
              field: "idCard",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "驾驶证号",
              itemType: "input",
              field: "driverLicenseNumber",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "营运证号",
              itemType: "input",
              field: "operationCertificateNo",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "危运证号",
              itemType: "input",
              field: "dangerousCertificateNo",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "账号",
              itemType: "selectloadmore",
              field: "userId",
              loadmoreMethod: "loadAccount",
              remotemethod: "remoteAccount",
              loading: false,
              setLabel: "username",
              setValue: "userId",
              placeholder: "输入账户名进行匹配",
              options: [],
            },
            // {
            //   span: 8,
            //   title: "驾驶证有效期",
            //   itemType: "date",
            //   field: "periodOfValidity",
            //   placeholder: "请选择",
            // },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "性别",
              itemType: "select",
              field: "sex",
              placeholder: "请选择",
              setLabel: "showName",
              setValue: "statusVal",
              options: [],
            },
            {
              span: 8,
              title: "民族",
              itemType: "input",
              field: "nation",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "出生日期",
              itemType: "date",
              field: "birthday",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "身份证发证机关",
              itemType: "input",
              field: "idcardIssuingAuthority",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "身份证有效期到",
              itemType: "date",
              field: "idcardValidity",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "住址",
              itemType: "input",
              field: "address",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "驾驶证初次领证日期",
              itemType: "date",
              field: "initialLicenseAcquisitionDate",
              placeholder: "请选择",
            },
            {
              span: 8,
              title: "准驾车型",
              itemType: "input",
              field: "approvedVehicleType",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "驾驶证有效期",
              itemType: "date",
              field: "periodOfValidity",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "驾驶证档案编号",
              itemType: "input",
              field: "driverLicenseFileNumber",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "犯罪记录",
              itemType: "textarea",
              field: "criminalRecord",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "身份证",
              itemType: "upload",
              slot: "img1",
            },
            {
              span: 12,
              title: "行驶证",
              itemType: "upload",
              slot: "img2",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "画像标签",
              itemType: "selectload",
              slot: "slotLabel",
            },
          ],
        },
      ],
      accountPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      CarrierPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      employeeIdPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
      },
      formRules: {
        driverAttributeConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        driverTypeConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        carrierId: [{ required: false, message: "请选择", trigger: "change" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入有效身份证号", trigger: "blur" },
        ],
        employeeId: [{ required: false, message: "请选择", trigger: "change" }],
        jobNumber: [{ required: false, message: "请输入", trigger: "blur" }],
        driverName: [{ required: true, message: "请输入", trigger: "blur" }],
        driverLicenseNumber: [
          { required: true, message: "请输入有效驾驶证号", trigger: "blur" },
        ],
      },
      baseModel: {},
      defaultBaseModel: {
        driverName: null,
        jobNumber: null,
        address: null,
        carrierId: null,
        dangerousCertificateNo: null,
        driverAttributeConfDictId: null,
        driverArchivalAttributeConfDictId: null,
        driverLicenseNumber: null,
        driverTypeConfDictId: null,
        idCard: null,
        operationCertificateNo: null,
        periodOfValidity: null,
        phone: null,
        remarks: null,
        tel: null,
        userId: null,

        // 新增的
        approvedVehicleType: null,
        birthday: null,
        criminalRecord: null,
        driverLicenseFileNumber: null,
        idcardIssuingAuthority: null,
        idcardValidity: null,
        initialLicenseAcquisitionDate: null,
        sex: null,
        idcardFiles: [],
        drivingLicenseFiles: [],
        // 运输从业资格证
        qualificationReq: {
          companyAddress: "",
          companyContacts: "",
          companyPhone: "",
          employmentNumber: "",
          fileIds: [],
          issuingAuthority: "",
          qualificationType: "",
          serviceCompany: "",
          validDateEnd: "",
          validDateStart: "",
        },
        portraitLabel: null,
        employeeId: null,
      },

      diaFormConfig2: [
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "从业资格证号",
              itemType: "input",
              field: "employmentNumber",
              placeholder: "请输入",
            },
            {
              span: 12,
              title: "发证机关",
              itemType: "input",
              field: "issuingAuthority",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "起始有效日期",
              itemType: "date",
              field: "validDateStart",
              placeholder: "请输入",
            },
            {
              span: 12,
              title: "有效期至",
              itemType: "date",
              field: "validDateEnd",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "服务单位",
              itemType: "input",
              field: "serviceCompany",
              placeholder: "请输入",
            },
            {
              span: 12,
              title: "单位地址",
              itemType: "input",
              field: "companyAddress",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 12,
              title: "单位电话",
              itemType: "input",
              field: "companyPhone",
              placeholder: "请输入",
            },
            {
              span: 12,
              title: "单位联系人",
              itemType: "input",
              field: "companyContacts",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "从业资格类别",
              itemType: "input",
              field: "qualificationType",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片上传",
              itemType: "upload",
              slot: "img3",
            },
          ],
        },
      ],
      isShowDialog2: false,
      fileNameLists_3: [],
      SexStatusLists: [],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
    // 司机类型&司机属性
    this.GetConfDictValDownList("driver_type:type");
    this.GetConfDictValDownList("driver_attribute");
    this.GetConfDictValDownList("driver_archival_attribute");
    this.GetAccountList();
    this.GetObjectUserDownList();
    this.getObjectUserDownLists();
  },
  methods: {
    async becomeRegularWorker() {
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        await this.$API
          .getDriverDetail({ driverId: this.selectTableData[0].driverId })
          .then((res) => {
            if (!res.data.result) {
              return false;
            }
            this.GetAccountList("", this.selectTableData[0].userId);
            let getdata = res.data.result || {};
            this.baseModel = getdata;

            let qualificationReq = {
              companyAddress: "",
              companyContacts: "",
              companyPhone: "",
              employmentNumber: "",
              fileIds: [],
              issuingAuthority: "",
              qualificationType: "",
              serviceCompany: "",
              validDateEnd: "",
              validDateStart: "",
            };
            this.listShipper = [];

            this.baseModel.qualificationReq =
              res.data.result.qualificationVo || qualificationReq;
            this.baseModel.driverArchivalAttributeConfDictId =
              this.driverArchivalAttributeConfDictIdArrs.find((n) => {
                return n.key == "zheng_shi";
              }).confDictId;
            this.AttributeChange(
              this.selectTableData[0].driverAttributeConfDictId
            );

            this.getSexStatusLists();

            // 回显图片
            let filesArr1 = res.data.result.idcardFiles || [];
            let filesArr2 = res.data.result.drivingLicenseFiles || [];

            let filesArr3 = [];
            if (res.data.result.qualificationVo) {
              filesArr3 = res.data.result.qualificationVo.fileIds || [];
            }

            let arrs1 = filesArr1.map((item) => {
              let objs = {
                name: item.fileId,
                url: item.fileUrl,
              };
              return objs;
            });
            let arrs2 = filesArr2.map((item) => {
              let objs = {
                name: item.fileId,
                url: item.fileUrl,
              };
              return objs;
            });
            let arrs3 = filesArr3.map((item) => {
              let objs = {
                name: item.fileId,
                url: item.fileUrl,
              };
              return objs;
            });

            this.fileNameLists_1 = arrs1 || [];
            this.fileNameLists_2 = arrs2 || [];
            this.fileNameLists_3 = arrs3 || [];

            let labels = res.data.result.portraitLabel || "";
            if (labels) {
              this.listShipper = labels.split(",").map((n) => {
                return {
                  label: n,
                };
              });
            }
          });
        this.$confirm("确定要转正所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              carrierIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.carrierIds.push(val.carrierId);
            });
            this.zhuanzheng();
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    zhuanzheng() {
      let param = {};
      for (let key in this.defaultBaseModel) {
        if (key == "qualificationReq") {
          param.qualificationReq = this.baseModel[key];
        } else if (this.baseModel[key]) {
          eval("param." + key + "='" + this.baseModel[key] + "'");
        } else {
          eval("param." + key + "=''");
        }
      }
      param.periodOfValidity = `${param.periodOfValidity} 00:00:00`;
      if (this.baseModel.driverId) param.driverId = this.baseModel.driverId;

      // 处理图片
      param.idcardFiles = this.fileNameLists_1.map((item) => {
        return item.name || [];
      });
      param.drivingLicenseFiles = this.fileNameLists_2.map((item) => {
        return item.name || [];
      });
      param.qualificationReq.fileIds = this.fileNameLists_3.map((item) => {
        return item.name || [];
      });
      param.portraitLabel =
        this.listShipper
          .map((n) => {
            return n.label;
          })
          .join() || "";
      // 修改接口
      this.$API.udpateDriver(param).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message);
          this.GetData();
        }
      });
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.dialogForm1 = {
        label: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      this.listShipper.push({
        label: this.dialogForm1.label,
      });
      this.isShowDialog1 = false;
    },
    clickDel(index) {
      this.listShipper.splice(index, 1);
    },
    async addlistShipper(key) {
      this.isShowDialog1 = true;
    },
    changeFileList_1(array) {
      this.fileNameLists_1 = array;
    },
    changeFileList_2(array) {
      this.fileNameLists_2 = array;
    },
    changeFileList_3(array) {
      this.fileNameLists_3 = array;
    },

    // 获取性别状态
    getSexStatusLists() {
      this.$TOOLS
        .getStatusValList("organization_employee_v1.sex")
        .then((res) => {
          // this.SexStatusLists = res || [];
          this.diaFormConfig[4].formItem[0].options = res || [];
        });
    },

    // 获取司机档案列表
    GetData() {
      this.selectTableData.length = 0;
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.getDriverList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---司机档案列表`);
        }
      });
    },

    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          let result = [];
          if (typeof res.data.result == "object" && res.data.result !== null) {
            res.data.result.map(function (value, index) {
              result.push({
                label: value.val,
                val: value.confDictId,
              });
            });
          }
          if (param === "driver_type:type") {
            this.diaFormConfig[0].formItem[1].options = result;
          }
          if (param === "driver_attribute") {
            this.diaFormConfig[0].formItem[0].options = result;
          }
          if (param === "driver_archival_attribute") {
            // if (
            //   typeof res.data.result == "object" &&
            //   res.data.result !== null
            // ) {
            //   res.data.result.map(function (value, index) {
            //     result.push({
            //       label: value.val,
            //       val: value.key,
            //     });
            //   });
            // }
            this.driverArchivalAttributeConfDictIdArrs = res.data.result || [];
            this.diaFormConfig[0].formItem[4].options = result;
          }
        }
      });
    },
    // 获取账号列表（select带分页）
    GetAccountList(e, checkedData) {
      let query = {
        pageStart: this.accountPage.pageStart,
        pageTotal: this.accountPage.pageTotal,
        name: e,
        userId: checkedData,
      };
      this.$API
        .wtl_getAccountList(query)
        .then((res) => {
          this.diaFormConfig[3].formItem[2].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result.data || [];
            console.log("result", result);
            let arr = this.diaFormConfig[3].formItem[2].options;
            if (e) {
              this.diaFormConfig[3].formItem[2].options = result;
            } else {
              this.diaFormConfig[3].formItem[2].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.userId === item.userId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.accountPage.pageCount = res.data.result?.pageCount || 0;
            }

            console.log("arr", arr);
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[4].formItem[0].loading = false;
        });
    },

    // 获取承运商 （select带分页）
    GetObjectUserDownList(e, checkedData) {
      let query = {
        pageStart: this.CarrierPage.pageStart,
        pageTotal: this.CarrierPage.pageTotal,
        name: e,
        key: "carrier",
        number: checkedData,
      };
      this.$API
        .wtl_getObjectUserDownList(query)
        .then((res) => {
          this.diaFormConfig[0].formItem[2].loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.diaFormConfig[0].formItem[2].options;
            if (e) {
              this.diaFormConfig[0].formItem[2].options = result;
            } else {
              this.diaFormConfig[0].formItem[2].options = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.number === item.number)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.CarrierPage.pageCount = res.data.result?.pageCount || 0;
            }
          }
        })
        .catch((catchres) => {
          this.diaFormConfig[0].formItem[2].loading = false;
        });
    },
    getObjectUserDownLists(e, checkedData) {
      // let query = {
      //   pageStart: this.employeeIdPage.pageStart,
      //   pageTotal: this.employeeIdPage.pageTotal,
      //   name: e,
      //   key: "employee",
      //   number: checkedData,
      // };
      // this.$API.wtl_getObjectUserDownList(query).then((res) => {
      //   let result = res.data.result.data || [];
      //   this.diaFormConfig[0].formItem[3].loading = false;
      //   let arr = this.diaFormConfig[0].formItem[3].options;
      //   if (e) {
      //     this.diaFormConfig[0].formItem[3].options = result;
      //   } else {
      //     this.diaFormConfig[0].formItem[3].options = [
      //       ...arr,
      //       ...result.filter(
      //         (item) => !arr.some((x) => x.number === item.number)
      //       ),
      //     ];
      //   }
      //   if (!e && !checkedData) {
      //     this.employeeIdPage.pageCount = res.data.result?.pageCount || 0;
      //   }
      // });
      this.$API
        .runPageReport({
          conditionReqs: [
            {
              conditonKey: "employeeName",
              conditonVal: e,
            },
          ],
          number: "down_list_employee",
          pageStart: this.employeeIdPage.pageStart,
          pageTotal: this.employeeIdPage.pageTotal,
        })
        .then((res) => {
          let result = res.data.result.datas.data || [];
          result.forEach((element) => {
            element.employeeId =
              (element.employeeId && String(element.employeeId)) || "";
          });
          this.diaFormConfig[0].formItem[3].loading = false;
          let arr = this.diaFormConfig[0].formItem[3].options;
          if (e) {
            this.diaFormConfig[0].formItem[3].options = result;
          } else {
            this.diaFormConfig[0].formItem[3].options = [
              ...arr,
              ...result.filter(
                (item) => !arr.some((x) => x.employeeId === item.employeeId)
              ),
            ];
          }
          if (!e && !checkedData) {
            this.employeeIdPage.pageCount = res.data.result?.pageCount || 0;
          }
        });
    },
    // 属性改变，改变必填项
    AttributeChange(e) {
      let arr = this.diaFormConfig[0].formItem[0].options;
      let index = arr.findIndex((element) => element.val == e);
      if (arr[index] && arr[index].label == "自有") {
        this.formRules.jobNumber[0].required = true;
        this.formRules.employeeId[0].required = true;
        this.formRules.carrierId[0].required = false;
      } else {
        this.formRules.employeeId[0].required = false;
      }
      if (arr[index] && arr[index].label == "外请") {
        this.formRules.jobNumber[0].required = false;
        this.formRules.carrierId[0].required = false;
      }
      if (arr[index] && arr[index].label == "承包") {
        this.formRules.carrierId[0].required = true;
        this.formRules.jobNumber[0].required = false;
      }
    },
    //  账号 select 滚动加载更多数据
    loadAccount() {
      let count = this.accountPage.pageCount / this.accountPage.pageTotal;
      if (count > this.accountPage.pageStart) {
        this.diaFormConfig[4].formItem[0].loading = true;
        this.accountPage.pageStart += 1;
        this.GetAccountList();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 账号远程搜索
    remoteAccount(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.accountPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[4].formItem[0].loading = true;
        this.GetAccountList(e);
      } else {
        this.GetAccountList();
      }
    },
    //  归属承运商 select 滚动加载更多数据
    loadCarrier() {
      let count = this.CarrierPage.pageCount / this.CarrierPage.pageTotal;
      if (count > this.CarrierPage.pageStart) {
        this.diaFormConfig[0].formItem[2].loading = true;
        this.CarrierPage.pageStart += 1;
        this.GetObjectUserDownList();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 归属承运商远程搜索
    remoteCarrier(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.CarrierPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[0].formItem[2].loading = true;
        this.GetObjectUserDownList(e);
      } else {
        this.GetObjectUserDownList();
      }
    },
    //  员工 select 滚动加载更多数据
    load_employeeId() {
      let count = this.employeeIdPage.pageCount / this.employeeIdPage.pageTotal;
      if (count > this.employeeIdPage.pageStart) {
        this.diaFormConfig[0].formItem[3].loading = true;
        this.employeeIdPage.pageStart += 1;
        this.getObjectUserDownLists();
      } else {
        console.log("数据已全部加载");
      }
    },
    // 员工远程搜索
    remote_employeeId(e) {
      // 当输入框有关键字的时候，loading为true显示加载圈圈，请求对应关键字数据
      this.employeeIdPage.pageStart = 1;
      if (e !== "") {
        this.diaFormConfig[0].formItem[3].loading = true;
        this.getObjectUserDownLists(e);
      } else {
        this.getObjectUserDownLists();
      }
    },
    selectChange_employeeId(e) {
      let arrs =
        this.diaFormConfig[0].formItem[3].options.find((n) => {
          return e == n.employeeId;
        }) || {};
      this.baseModel.phone = arrs.phone || "";
      this.baseModel.jobNumber = arrs.jobNumber || "";
      this.baseModel.driverName = arrs.employeeName || "";
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.baseModel = JSON.parse(JSON.stringify(this.defaultBaseModel));
      this.isShowDialog = true;
      this.listShipper = [];
      this.getSexStatusLists();
    },
    // 修改
    modifyClick(row) {
      let datas = [];

      if (row) {
        datas = [row];
      } else {
        if (this.selectTableData.length !== 1) {
          this.$message.error("请选择一条数据进行操作");
          return false;
        }
        datas = this.selectTableData;
      }
      this.$API.getDriverDetail({ driverId: datas[0].driverId }).then((res) => {
        if (!res.data.result) {
          return false;
        }
        this.GetAccountList("", datas[0].userId);
        this.baseModel = res.data.result || {};
        let qualificationReq = {
          companyAddress: "",
          companyContacts: "",
          companyPhone: "",
          employmentNumber: "",
          fileIds: [],
          issuingAuthority: "",
          qualificationType: "",
          serviceCompany: "",
          validDateEnd: "",
          validDateStart: "",
        };
        this.listShipper = [];

        this.baseModel.qualificationReq =
          res.data.result.qualificationVo || qualificationReq;
        this.AttributeChange(datas[0].driverAttributeConfDictId);

        this.getSexStatusLists();

        // 回显图片
        let filesArr1 = res.data.result.idcardFiles || [];
        let filesArr2 = res.data.result.drivingLicenseFiles || [];

        let filesArr3 = [];
        if (res.data.result.qualificationVo) {
          filesArr3 = res.data.result.qualificationVo.fileIds || [];
        }

        let arrs1 = filesArr1.map((item) => {
          let objs = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return objs;
        });
        let arrs2 = filesArr2.map((item) => {
          let objs = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return objs;
        });
        let arrs3 = filesArr3.map((item) => {
          let objs = {
            name: item.fileId,
            url: item.fileUrl,
          };
          return objs;
        });

        this.fileNameLists_1 = arrs1 || [];
        this.fileNameLists_2 = arrs2 || [];
        this.fileNameLists_3 = arrs3 || [];

        let labels = res.data.result.portraitLabel || "";
        if (labels) {
          this.listShipper = labels.split(",").map((n) => {
            return {
              label: n,
            };
          });
        }
        this.isShowDialog = true;
      });
    },
    // 删除
    delete(data) {
      console.log(this.selectTableData);
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              driverIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.driverIds.push(val.driverId);
            });
            this.$API.delDriver(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.driverIds.length > 2) {
                    delReq.driverIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.driverId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.driverId == delReq.driverIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 启用
    startUsing(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "启用";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认${msg}所选数据?`, "提示:")
          .then((res) => {
            let params = {
              driverIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.driverIds.push(val.driverId);
            });

            if (t) {
              // 禁用接口
              this.$API.stopDriver(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            } else {
              // 启用接口
              this.$API.startDriver(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(`已${msg}`);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 禁用
    Disable(data) {
      this.startUsing(data, "禁用");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    //  表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (key == "qualificationReq") {
              param.qualificationReq = this.baseModel[key];
            } else if (this.baseModel[key]) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          console.log("param", param);

          param.periodOfValidity = `${param.periodOfValidity} 00:00:00`;
          if (this.baseModel.driverId) param.driverId = this.baseModel.driverId;

          // 处理图片
          param.idcardFiles = this.fileNameLists_1.map((item) => {
            return item.name || [];
          });
          param.drivingLicenseFiles = this.fileNameLists_2.map((item) => {
            return item.name || [];
          });
          param.qualificationReq.fileIds = this.fileNameLists_3.map((item) => {
            return item.name || [];
          });
          param.portraitLabel =
            this.listShipper
              .map((n) => {
                return n.label;
              })
              .join() || "";

          if (param.driverId) {
            // 修改接口
            this.$API.udpateDriver(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
                this.ResetConfig();
              }
            });
          } else {
            // 新增接口
            this.$API.addDriver(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
                this.ResetConfig();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.diaCancelBtn();
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.baseModel = {};

      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
      this.ResetConfig();
    },
    ResetConfig() {
      this.accountPage.pageStart = 1;
      this.CarrierPage.pageStart = 1;
      this.employeeIdPage.pageStart = 1;
      this.diaFormConfig[4].formItem[0].options = [];
      this.diaFormConfig[0].formItem[2].options = [];
      this.diaFormConfig[0].formItem[3].options = [];
      this.GetAccountList();
      this.GetObjectUserDownList();
      this.getObjectUserDownLists();
    },
  },
};
</script>
<style scoped lang="less">
.topLine {
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #d7d7d7;
  padding: 8px;
}
.setper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 6px;
  border: 1px dashed #cccccc;
  .s_tem {
    margin: 6px;
    .el-icon-error {
      cursor: pointer;
      color: red;
    }
  }
}
</style>
    